import { useState, useCallback } from 'react'
import useApiRequest from '../hooks/useApiRequest'

const useBonusHistory = (bonusesPath, t) => {
  const [bonuses, setBonuses] = useState(null)
  const [hasError, setHasError] = useState(false)
  const [hasFetched, setHasFetched] = useState(false)
  const [isShowingBonusHistory, setIsShowingBonusHistory] = useState(false)
  const { isLoading, sendRequest } = useApiRequest()

  const fetchBonuses = useCallback(async () => {
    if (hasFetched || isLoading) return

    setHasError(false)
    setHasFetched(true)

    try {
      const data = await sendRequest(bonusesPath)
      setBonuses(data.collection_adjustments)
    } catch (error) {
      setHasError(true)
      window.alert(t['tcnext.failed_to_fetch_bonus_history'])
    }
  }, [bonusesPath, sendRequest, t, hasFetched, isLoading])

  const toggleBonusHistory = useCallback(
    (e) => {
      e.preventDefault()

      if (!isShowingBonusHistory && !hasFetched) {
        fetchBonuses()
      }

      setIsShowingBonusHistory((prevState) => !prevState)
    },
    [isShowingBonusHistory, hasFetched, fetchBonuses],
  )

  return {
    bonuses,
    hasError,
    isLoading,
    isShowingBonusHistory,
    toggleBonusHistory,
  }
}

export default useBonusHistory
